export interface TVSeries {
  id: number;
  title: string;
  cover: string;
  banner: string;
  category: string;
  categorySlug: string;
  year: number;
  episodes: number;
  status: '更新中' | '已完结';
  rating: number;
  description: string;
  longDescription: string;
  director: string;
  cast: string[];
  tags: string[];
  featured: boolean;
  hot: boolean;
  updateDay: string;
}

export interface Category {
  name: string;
  slug: string;
  icon: string;
  count: number;
}

export const categories: Category[] = [
  { name: '古装仙侠', slug: 'guzhuang-xianxia', icon: 'ri-sword-line', count: 12 },
  { name: '都市情感', slug: 'dushi-qinggan', icon: 'ri-building-line', count: 18 },
  { name: '悬疑推理', slug: 'xuanyi-tuili', icon: 'ri-search-eye-line', count: 10 },
  { name: '喜剧搞笑', slug: 'xiju-gaoxiao', icon: 'ri-emotion-laugh-line', count: 8 },
  { name: '科幻奇幻', slug: 'kehuan-qihuan', icon: 'ri-rocket-line', count: 7 },
  { name: '历史传奇', slug: 'lishi-chuanqi', icon: 'ri-ancient-gate-line', count: 9 },
  { name: '青春校园', slug: 'qingchun-xiaoyuan', icon: 'ri-book-read-line', count: 6 },
  { name: '动作武侠', slug: 'dongzuo-wuxia', icon: 'ri-boxing-line', count: 5 },
];

export const tvSeries: TVSeries[] = [
  {
    id: 1,
    title: '长安十二时辰',
    cover: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20with%20Tang%20Dynasty%20warrior%20in%20red%20robe%20standing%20on%20city%20wall%20at%20sunset%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20clean%20background%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-01&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Tang%20Dynasty%20Changan%20city%20night%20scene%20with%20lanterns%20and%20ancient%20architecture%2C%20dramatic%20warm%20lighting%2C%20cinematic%20wide%20shot%2C%20mysterious%20atmosphere%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-01&orientation=landscape',
    category: '古装仙侠',
    categorySlug: 'guzhuang-xianxia',
    year: 2019,
    episodes: 48,
    status: '已完结',
    rating: 8.2,
    description: '唐朝上元节前夕，长安城陷入惊天危机，死囚张小敬临危受命，与天才少年李必携手在十二时辰内拯救长安。',
    longDescription: '本剧改编自马伯庸同名小说，讲述了唐朝天宝三载上元节前夕，长安城混入可疑狼卫，陷入危局。原不良帅张小敬因罪入狱，被靖安司司丞李必看中，两人必须在十二个时辰内破除隐患，拯救长安城的故事。剧集以精巧的时间叙事结构，展现了唐代长安城的繁华盛景与波谲云诡的权谋斗争，每一集对应一个时辰，节奏紧凑，环环相扣。',
    director: '曹盾',
    cast: ['雷佳音', '易烊千玺', '周一围', '芦芳生', '热依扎'],
    tags: ['古装', '悬疑', '权谋', '历史'],
    featured: true,
    hot: true,
    updateDay: '已完结',
  },
  {
    id: 2,
    title: '狂飙',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20drama%20poster%20with%20two%20men%20in%20dark%20suits%20facing%20each%20other%20in%20urban%20night%20setting%2C%20intense%20expression%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-02&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cityscape%20at%20dusk%20with%20dramatic%20sky%2C%20urban%20architecture%2C%20moody%20atmosphere%2C%20crime%20drama%20aesthetic%2C%20cinematic%20wide%20shot%2C%20professional%20production%20quality&width=1600&height=700&seq=tv-banner-02&orientation=landscape',
    category: '悬疑推理',
    categorySlug: 'xuanyi-tuili',
    year: 2023,
    episodes: 39,
    status: '已完结',
    rating: 8.5,
    description: '一线刑警安欣与黑恶势力高启强长达二十年的正邪较量，展现了扫黑除恶的艰辛历程。',
    longDescription: '电视剧《狂飙》讲述了以一线刑警安欣为代表的正义力量，与以高启强为首的黑恶势力展开的长达二十年生死较量的故事。剧集通过群像叙事展现扫黑行动中的黑白较量和复杂人性，深度刻画了中国社会二十年的时代变迁。剧中的每个角色都鲜活立体，表演真实动人，堪称近年国产剧的巅峰之作。',
    director: '徐纪周',
    cast: ['张译', '张颂文', '李一桐', '张志坚', '吴刚'],
    tags: ['犯罪', '悬疑', '扫黑', '现实题材'],
    featured: true,
    hot: true,
    updateDay: '已完结',
  },
  {
    id: 3,
    title: '三体',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20drama%20poster%20with%20mysterious%20three%20suns%20in%20dark%20space%2C%20futuristic%20elements%2C%20cosmic%20scale%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-03&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Deep%20space%20with%20mysterious%20cosmic%20phenomenon%2C%20distant%20planet%20with%20three%20stars%2C%20futuristic%20laboratory%20in%20foreground%2C%20sci-fi%20aesthetic%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-03&orientation=landscape',
    category: '科幻奇幻',
    categorySlug: 'kehuan-qihuan',
    year: 2023,
    episodes: 30,
    status: '已完结',
    rating: 8.0,
    description: '纳米科学家汪淼卷入神秘事件，揭开地球文明与三体文明之间的生死搏杀序幕。',
    longDescription: '改编自刘慈欣同名科幻巨著《三体》，讲述了纳米科学家汪淼被警官史强带到联合作战中心，潜入名为"科学边界"的组织协助调查。在深入调查的过程中，汪淼接触到了一个名为ETO的组织，发现了三体文明的存在。全剧以宏大的宇宙观和精妙的科学构思，呈现了一场跨越星际的文明博弈，是中国科幻影视的里程碑之作。',
    director: '杨磊',
    cast: ['张鲁一', '于和伟', '陈瑾', '王子文', '林永健'],
    tags: ['科幻', '悬疑', '宇宙', '文明'],
    featured: true,
    hot: false,
    updateDay: '已完结',
  },
  {
    id: 4,
    title: '漫长的季节',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20drama%20poster%20with%20middle-aged%20man%20looking%20at%20autumn%20scenery%20in%20northeast%20China%2C%20nostalgic%20warm%20tones%2C%20melancholy%20atmosphere%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-04&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Northeast%20China%20autumn%20landscape%20with%20golden%20leaves%20and%20old%20factory%20buildings%2C%20nostalgic%20atmosphere%2C%20warm%20golden%20hour%20lighting%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-04&orientation=landscape',
    category: '悬疑推理',
    categorySlug: 'xuanyi-tuili',
    year: 2023,
    episodes: 12,
    status: '已完结',
    rating: 9.4,
    description: '出租车司机王响和妹夫龚彪在追查套牌车的过程中，揭开了一桩尘封二十年的碎尸悬案。',
    longDescription: '《漫长的季节》是一部极具文学质感的社会派悬疑剧。故事围绕出租车司机王响展开，他在追查一辆套牌出租车的过程中，意外牵出了一段尘封二十年的往事。剧集在三个时间线之间自如切换，既是一部扣人心弦的悬疑剧，也是一曲关于时代、命运与尊严的挽歌。范伟的表演入木三分，豆瓣评分高达9.4分，被誉为年度最佳国剧。',
    director: '辛爽',
    cast: ['范伟', '秦昊', '陈明昊', '李庚希', '刘琳'],
    tags: ['悬疑', '社会派', '东北', '人性'],
    featured: false,
    hot: true,
    updateDay: '已完结',
  },
  {
    id: 5,
    title: '苍兰诀',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20drama%20poster%20with%20beautiful%20couple%20in%20ancient%20flowing%20robes%20surrounded%20by%20magical%20orchid%20flowers%2C%20dreamy%20atmosphere%2C%20ethereal%20lighting%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-05&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Magical%20fantasy%20world%20with%20floating%20islands%20and%20ancient%20Chinese%20palaces%2C%20ethereal%20purple%20and%20gold%20sky%2C%20dreamy%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20quality%20fantasy%20production%20design&width=1600&height=700&seq=tv-banner-05&orientation=landscape',
    category: '古装仙侠',
    categorySlug: 'guzhuang-xianxia',
    year: 2022,
    episodes: 36,
    status: '已完结',
    rating: 7.9,
    description: '天界低阶仙女小兰花与月尊东方青苍因意外互换身体，由此展开一段甜虐交织的仙侠爱恋。',
    longDescription: '《苍兰诀》讲述了天界低阶仙女小兰花无意间闯入上古遗迹，与被困万年的月尊东方青苍因一株上古兰草而命运相连的故事。两人从互相嫌弃到相知相恋，经历三界动荡与命运抉择。剧集以其瑰丽的东方奇幻美学、精致的服化道和新颖的人设，在播出期间引发追剧热潮，成为年度爆款古装仙侠剧。',
    director: '伊峥',
    cast: ['虞书欣', '王鹤棣', '徐海乔', '郭晓婷', '张凌赫'],
    tags: ['仙侠', '爱情', '奇幻', '东方美学'],
    featured: true,
    hot: false,
    updateDay: '已完结',
  },
  {
    id: 6,
    title: '去有风的地方',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20healing%20drama%20poster%20with%20woman%20standing%20in%20Yunnan%20countryside%20field%20with%20gentle%20breeze%2C%20warm%20sunlight%2C%20pastoral%20peaceful%20vibe%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-06&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Beautiful%20Yunnan%20countryside%20with%20terraced%20fields%20and%20traditional%20village%20houses%20under%20warm%20sunlight%2C%20pastoral%20peaceful%20landscape%2C%20gentle%20breeze%20through%20grass%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production&width=1600&height=700&seq=tv-banner-06&orientation=landscape',
    category: '都市情感',
    categorySlug: 'dushi-qinggan',
    year: 2023,
    episodes: 40,
    status: '已完结',
    rating: 8.1,
    description: '辞职后的许红豆来到大理云苗村，在"有风小院"邂逅了一群温暖的人，开启了治愈之旅。',
    longDescription: '《去有风的地方》讲述了五星级酒店前厅经理许红豆在好友去世后，生活和工作陷入低谷，独自前往大理云苗村的"有风小院"休息调整。在那里，她遇到了辞去高薪工作回乡创业的当地人谢之遥，还有一群从大城市过去的同龄人。在日常相处中，他们互相治愈、重获力量，找到了重新出发的勇气。该剧以大理的自然风光为背景，展现了一种令人向往的田园生活。',
    director: '丁梓光',
    cast: ['刘亦菲', '李现', '胡冰卿', '牛骏峰', '吴彦姝'],
    tags: ['治愈', '田园', '爱情', '大理'],
    featured: false,
    hot: true,
    updateDay: '已完结',
  },
  {
    id: 7,
    title: '庆余年',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20poster%20with%20young%20man%20in%20elegant%20ancient%20robe%20holding%20a%20book%2C%20palace%20background%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-07&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20imperial%20palace%20interior%20with%20golden%20dragon%20decorations%2C%20grand%20architecture%2C%20dramatic%20warm%20lighting%20from%20candles%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-07&orientation=landscape',
    category: '历史传奇',
    categorySlug: 'lishi-chuanqi',
    year: 2019,
    episodes: 46,
    status: '已完结',
    rating: 7.9,
    description: '身世神秘的少年范闲，自海边小城初出茅庐，历经家族、江湖、庙堂的种种考验与锤炼。',
    longDescription: '《庆余年》改编自猫腻同名小说，讲述了一个身世神秘的少年范闲，从海边小城澹州走出，历经家族纷争、江湖恩怨和朝堂权谋的考验。范闲凭借着过人的智慧和勇气，在庆国的庙堂之上书写了一段传奇人生。剧集将历史架空、权谋斗争、武侠动作与幽默元素巧妙融合，既有大格局的史诗感，又不乏轻松幽默的日常，是近年最成功的男频IP改编作品。',
    director: '孙皓',
    cast: ['张若昀', '李沁', '陈道明', '吴刚', '李小冉'],
    tags: ['权谋', '武侠', '架空历史', '成长'],
    featured: true,
    hot: false,
    updateDay: '已完结',
  },
  {
    id: 8,
    title: '山河令',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20wuxia%20drama%20poster%20with%20two%20elegant%20men%20in%20flowing%20white%20and%20red%20ancient%20robes%2C%20mountain%20landscape%20background%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-08&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mountain%20landscape%20with%20misty%20peaks%20and%20ancient%20temples%2C%20wuxia%20aesthetic%2C%20dramatic%20clouds%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-08&orientation=landscape',
    category: '动作武侠',
    categorySlug: 'dongzuo-wuxia',
    year: 2021,
    episodes: 36,
    status: '已完结',
    rating: 8.6,
    description: '天窗首领周子舒为求自由离开组织，命不久矣时遇上一心灭世的鬼谷谷主温客行，两人卷入江湖纷争。',
    longDescription: '《山河令》改编自Priest小说《天涯客》，讲述了天窗首领周子舒为求自由，不惜以生命为代价离开组织。在生命所剩无几之时，他遇到了行为乖张的鬼谷谷主温客行，两人因一卷涉及江湖秘宝的琉璃甲而卷入一场江湖纷争。剧集以其精美的武侠打斗设计、诗意的台词和深刻的角色塑造赢得了观众的喜爱，被誉为近年来武侠剧的代表作。',
    director: '成志超',
    cast: ['张哲瀚', '龚俊', '周也', '马闻远', '孙浠伦'],
    tags: ['武侠', '江湖', '双男主', '古装'],
    featured: false,
    hot: false,
    updateDay: '已完结',
  },
  {
    id: 9,
    title: '你好，火焰蓝',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20firefighter%20drama%20poster%20with%20firefighter%20in%20uniform%20standing%20in%20front%20of%20fire%20truck%2C%20heroic%20atmosphere%2C%20dramatic%20lighting%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-09&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Fire%20station%20with%20red%20fire%20trucks%20at%20sunset%2C%20heroic%20atmosphere%2C%20warm%20golden%20light%2C%20modern%20Chinese%20city%20background%2C%20cinematic%20wide%20shot%2C%20professional%20production%20quality&width=1600&height=700&seq=tv-banner-09&orientation=landscape',
    category: '都市情感',
    categorySlug: 'dushi-qinggan',
    year: 2021,
    episodes: 24,
    status: '已完结',
    rating: 7.2,
    description: '消防员霍言与急诊医生晏蓝在一次救援中相遇，两人从最初的误会到相互理解与支持。',
    longDescription: '《你好，火焰蓝》讲述了消防站副站长霍言与急诊科医生晏蓝在一次突发事件中相遇，起初因误会而对立，后来在一次次生死救援中逐渐理解彼此的职业使命，从相互嫌弃到相互敬佩，最终走到一起的故事。剧集展现了中国消防员和医护人员的职业精神与大爱担当，同时也描绘了年轻人在事业与爱情中的成长。',
    director: '张力川',
    cast: ['龚俊', '张慧雯', '庞瀚辰', '周彦辰', '王梓薇'],
    tags: ['消防', '医疗', '爱情', '职业'],
    featured: false,
    hot: false,
    updateDay: '已完结',
  },
  {
    id: 10,
    title: '星汉灿烂',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20drama%20poster%20with%20young%20woman%20in%20elegant%20Han%20Dynasty%20style%20robe%20under%20starry%20sky%2C%20romantic%20atmosphere%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-10&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20military%20camp%20under%20vast%20starry%20night%20sky%2C%20historical%20drama%20aesthetic%2C%20bonfire%20light%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-10&orientation=landscape',
    category: '历史传奇',
    categorySlug: 'lishi-chuanqi',
    year: 2022,
    episodes: 56,
    status: '已完结',
    rating: 7.7,
    description: '程少商自幼与父母分离，在战乱中艰难成长，后与少年将军凌不疑相知相恋，共同成长。',
    longDescription: '《星汉灿烂》改编自关心则乱小说《星汉灿烂，幸甚至哉》，讲述了程家四娘子程少商因战乱自幼与父母分离，在祖母身边长大成为一个"留守少女"。后随家族迁徙至都城，邂逅了少年将军凌不疑，两人在乱世中相知相恋，携手面对家族恩怨与家国天下。剧集以轻喜剧的笔触描绘了人物的成长历程，在爱情之外也探讨了家庭与责任的主题。',
    director: '费振翔',
    cast: ['赵露思', '吴磊', '郭涛', '曾黎', '李昀锐'],
    tags: ['古装', '爱情', '成长', '轻喜剧'],
    featured: false,
    hot: true,
    updateDay: '已完结',
  },
  {
    id: 11,
    title: '偷偷藏不住',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20youth%20romance%20drama%20poster%20with%20young%20couple%20on%20university%20campus%2C%20sweet%20atmosphere%2C%20cherry%20blossoms%2C%20warm%20sunlight%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-11&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Beautiful%20university%20campus%20with%20cherry%20blossom%20trees%20in%20spring%2C%20young%20students%20walking%2C%20warm%20sunlight%2C%20romantic%20atmosphere%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production&width=1600&height=700&seq=tv-banner-11&orientation=landscape',
    category: '青春校园',
    categorySlug: 'qingchun-xiaoyuan',
    year: 2023,
    episodes: 25,
    status: '已完结',
    rating: 7.3,
    description: '高中生桑稚暗恋哥哥的朋友段嘉许多年，这段少女心事最终开花结果。',
    longDescription: '《偷偷藏不住》改编自竹已同名小说，讲述了高中生桑稚偷偷喜欢着哥哥的朋友段嘉许，这段少女心事被她藏在心底多年。随着桑稚步入大学，两人之间的交集逐渐增多，曾经遥不可及的暗恋对象变得越来越近。剧集以清新甜美的笔触描绘了一段从少女暗恋到双向奔赴的纯爱故事，赵露思与陈哲远的荧幕CP感十足，播出期间频频登上热搜。',
    director: '李青蓉',
    cast: ['赵露思', '陈哲远', '马伯骞', '张柏嘉', '顾书齐'],
    tags: ['青春', '暗恋', '校园', '甜蜜'],
    featured: false,
    hot: false,
    updateDay: '已完结',
  },
  {
    id: 12,
    title: '异人之下',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20supernatural%20drama%20poster%20with%20young%20man%20surrounded%20by%20mystical%20energy%20and%20martial%20arts%20pose%2C%20urban%20fantasy%20style%2C%20dynamic%20lighting%2C%20cinematic%20style%2C%20professional%20TV%20series%20poster%20design&width=600&height=800&seq=tv-cover-12&orientation=portrait',
    banner: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20city%20with%20supernatural%20energy%20waves%20and%20martial%20arts%20elements%2C%20urban%20fantasy%20aesthetic%2C%20dynamic%20night%20scene%2C%20cinematic%20wide%20shot%2C%20high%20quality%20production%20design&width=1600&height=700&seq=tv-banner-12&orientation=landscape',
    category: '科幻奇幻',
    categorySlug: 'kehuan-qihuan',
    year: 2023,
    episodes: 27,
    status: '已完结',
    rating: 8.0,
    description: '平凡大学生张楚岚因爷爷的失踪被迫卷入异人世界，从此开启了一段惊心动魄的冒险之旅。',
    longDescription: '《异人之下》改编自米二创作的漫画《一人之下》，讲述了平凡大学生张楚岚因爷爷尸体离奇失踪，被卷入前所未见的"异人"世界。在这个隐藏于都市阴影中的异能世界里，他遇到了神秘少女冯宝宝，两人一同踏上了寻找真相的旅程。剧集将中国传统武术、道家文化与现代都市奇幻完美结合，动作场面精彩绝伦，世界观构建宏大而独特。',
    director: '许宏宇',
    cast: ['彭昱畅', '侯明昊', '王影璐', '毕雯珺', '王学圻'],
    tags: ['奇幻', '热血', '异能', '漫画改编'],
    featured: false,
    hot: false,
    updateDay: '已完结',
  },
];

export const faqData = [
  {
    question: '天美影视的电视剧资源是高清的吗？',
    answer: '是的，天美影视所有电视剧资源均提供高清画质，大部分剧集支持1080P甚至4K分辨率。我们采用先进的视频编码技术，确保画质清晰的同时，也优化了加载速度，让您享受不缓冲的流畅追剧体验。',
  },
  {
    question: '在天美影视观看电视剧需要付费吗？',
    answer: '天美影视提供完全免费的电视剧在线观看服务。您无需注册账号，也无需支付任何费用，即可畅享海量最新、最热门的电视剧资源。我们致力于为所有用户提供优质的免费追剧体验。',
  },
  {
    question: '天美影视支持哪些设备观看？',
    answer: '天美影视支持全平台观看，包括电脑端（Windows/Mac）、移动端（iOS/Android手机和平板）以及智能电视。无论您在哪里，只要有网络连接，就可以随时随地畅享追剧乐趣。',
  },
  {
    question: '新剧上线后多久可以在天美影视上看到？',
    answer: '我们拥有专业的运营团队，热门新剧通常会在首播后24小时内完成高清资源的更新。部分热门剧集甚至可以实现与电视台同步更新，让您第一时间追到最新剧情。',
  },
  {
    question: '天美影视的电视剧资源包含哪些类型？',
    answer: '天美影视涵盖了古装仙侠、都市情感、悬疑推理、喜剧搞笑、科幻奇幻、历史传奇、青春校园、动作武侠等多种类型的电视剧资源。无论您喜欢哪种风格，都能在这里找到心仪的剧集。',
  },
  {
    question: '观看过程中遇到卡顿怎么办？',
    answer: '天美影视采用多线路智能切换技术，当检测到当前线路不流畅时，会自动为您切换到最优线路。如果您仍然遇到问题，可以尝试手动切换清晰度或刷新页面，获得更流畅的追剧体验。',
  },
];